var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("grid grid-cols-2 md:grid-cols-" + _vm.columns + " gap-x-4 md:gap-x-6 gap-y-10 md:gap-y-16")},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }